import React from "react";

// interfaces
import { IIconComponentProps } from "@/types/components/IconComponentProps";

const HouseLocationPin = (props: IIconComponentProps<HTMLSpanElement>) => (
  <span {...props}>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.001 16.0153V20.5042C14.001 20.7803 14.2151 21.0044 14.4802 21.0044H19.5253C19.7894 21.0044 20.0035 20.7803 20.0035 20.5042V15.9883"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.001 16.6681L17.0847 14L21.0043 16.6681"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4557 12.8665C11.8276 12.8665 12.9397 11.7544 12.9397 10.3825C12.9397 9.01058 11.8276 7.89844 10.4557 7.89844C9.08382 7.89844 7.97168 9.01058 7.97168 10.3825C7.97168 11.7544 9.08382 12.8665 10.4557 12.8665Z"
        stroke="#22282D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8918 10.9234C18.0218 8.86154 17.3055 6.75666 15.7299 5.181C12.8167 2.26779 8.09471 2.26779 5.18149 5.181C2.26828 8.09422 2.26828 12.8162 5.18149 15.7294L10.4557 21.0036"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);
export default HouseLocationPin;
